import { render, staticRenderFns } from "./CustomerRender.vue?vue&type=template&id=14b42d06"
import script from "./CustomerRender.vue?vue&type=script&lang=js"
export * from "./CustomerRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports